import type { CMSLinkGroupProps } from "@jwm/types/CMSLinkGroupProps";

import { getLink } from "./getLink";

export const mapLinkGroupProps = (
    cmsLinkGroupProps: CMSLinkGroupProps
): { external: boolean; url: string; url_prefix: string } => {
    return getLink(cmsLinkGroupProps);
};
